import CoreApi from '../CoreApi';

class CoreService extends CoreApi {
  constructor(endpoint, withCredentials = true) {
    super();

    // use global enpoint for service if needed, i.e '/utils'
    if (endpoint) {
      this.endpoint = endpoint;
      this.setEndpointUrl(this.endpoint);
    }
    if (withCredentials) {
      this.api.defaults.withCredentials = true;
    }
  }

  setEndpointUrl(url) {
    this.api.defaults.baseURL = this.baseUrl + url;
  }
}

export default CoreService;
